import interact from 'interactjs'
export default {
  data () {
    return {
      position: {
        x: 0,
        y: 0
      },
      is_moving: 0,
      updateImagesSet: [],
      resequenceImageSet: []
    }
  },
  methods: {
    dragMoveListener: function (event) {
      var target = event.target
      var self = this
      self.position.x += event.dx
      self.position.y += event.dy

      // translate the element
      target.style.webkitTransform =
                target.style.transform =
                'translate(' + self.position.x + 'px, ' + self.position.y + 'px)'

      // update the posiion attributes
      target.setAttribute('data-x', self.position.x)
      target.setAttribute('data-y', self.position.y)
    },
    resetPosition: function (event) {
      this.position.x = 0
      this.position.y = 0
      event.relatedTarget.setAttribute('data-x', 0)
      event.relatedTarget.setAttribute('data-y', 0)
      event.relatedTarget.style.webkitTransform =
                event.relatedTarget.style.transform =
                'translate(' + 0 + 'px, ' + 0 + 'px)'
    },

    DnD: function () {
      var self = this
      interact('.dropzone').dropzone({
        // accept: '.incoming-image',
        overlap: 0.75,

        ondropactivate: function (event) {
          // event.relatedTarget.classList.add('drop-active')
          event.target.classList.add('drop-active')
        },
        ondragenter: function (event) {
          var draggableElement = event.relatedTarget
          var dropzoneElement = event.target

          var y = draggableElement.getAttribute('data-y') - event.relatedTarget.offsetTop + event.dragEvent.clientY

          if (self.is_moving == 0) {
            draggableElement.style.webkitTransform =
                            draggableElement.style.transform =
                            'translateY(' + y + 'px)'
            draggableElement.setAttribute('data-y', y || 0)
          }
          self.is_moving = 1

          dropzoneElement.classList.add('drop-target')
          draggableElement.classList.add('drag-helper')
          dropzoneElement.classList.add('can-drop')
        },
        ondragleave: function (event) {
          event.target.classList.remove('drop-target')
          event.relatedTarget.classList.remove('can-drop')
        },
        ondrop: function (event) {
          self.resetPosition(event)

          var source = $(event.relatedTarget).find('img').attr('src')

          var id_image = $(event.relatedTarget).find('.id_image').val()
          var id_product_image = $(event.target).find('.id_product_image').val()

          $(event.target).find('.v-image__image').css('background-image', 'url("' + source + '")')
          $(event.target).attr('id', id_image)

          if (self.updateImagesSet) {
            self.updateImagesSet.push({
              'id_product_image': id_product_image,
              'id_image': id_image
            })
          }

          self.updateRequired = true
          event.relatedTarget.classList.add('drag-helper')
          self.$store.dispatch('updateimagesUpdateRequired', true)
          self.$store.dispatch('updateimagesUpdateSet', self.updateImagesSet)
          self.$store.dispatch('updateSequenceUpdateSet', $('.property-items').sortable('toArray'))

          self.is_moving = 0
        },
        ondropdeactivate: function (event) {
          self.resetPosition(event)
          event.relatedTarget.classList.remove('drag-helper')
          event.target.classList.remove('drop-active')
          event.target.classList.remove('drop-target')

          self.is_moving = 0
        }
      })

      interact('.drag-drop').draggable({
        inertia: false,
        autoScroll: true,
        onmove: self.dragMoveListener
      })
    }
  }
}
